import { NameServerResponse } from "../../../../../../api/resources/Networking/NamesServer";
import { keysOf } from "../../../../../../shared-functions/objects";
import { safeToLowerCase } from "../../../../../../shared-functions/string";
import { Subnet } from "../../types/subnet";

export const getDefaultNameservers = ({
  nameservers,
  ipVersion,
  region,
}: {
  nameservers: NameServerResponse;
  ipVersion: number;
  region?: string;
}) => {
  if (!region || !keysOf(nameservers).length) return "";
  const regionData = nameservers?.[safeToLowerCase(region)];
  if (!regionData) return "";
  const defaultValue =
    regionData[`ipv${ipVersion}` as "ipv4" | "ipv6"]?.join(", ") || "";
  return defaultValue;
};

export const getDefaultCIDR = (zoneId: number) => {
  return `10.${zoneId}.0.0/24`;
};

export const getDefaultGatewayIP = (zoneId: number) => {
  return `10.${zoneId}.0.1`;
};

export const getDefaultAllocationPools = (zoneId: number) => {
  return [{ start: `10.${zoneId}.0.10`, end: `10.${zoneId}.0.200` }];
};

export const createInitialSubnet = (
  zoneId: number,
  defaultNameservers: string,
): Subnet => {
  return {
    ipVersion: 4,
    name: "",
    dnsNameservers: defaultNameservers || "",
    enableHostRoutes: false,
    hostRoutes: [{ nexthop: "", destination: "" }],

    //IPv4 values
    cidr: getDefaultCIDR(zoneId),
    enableGateway: true,
    gatewayIp: getDefaultGatewayIP(zoneId),
    enableDhcp: true,
    allocationPools: getDefaultAllocationPools(zoneId),
  };
};
